import {Vignoble} from "../components/vineyard_team/VineyardDisplay"


export default function Vineyard() {
    return (
        <>
        <Vignoble/>
        </>
    )
}